import { Component, ComponentFactoryResolver, ComponentRef, ElementRef, OnDestroy, OnInit, Type, ViewChild, ViewContainerRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { messagefromComponent } from '../../class/appinterface';
import { Contatto } from '../../components/CRM/crm-contatti/interfaces';
import { NicaMaster } from '../../components/nica-master-component/nica-master.component';
import { OverlaySideFormService } from '../../components/shared/overlay-side-form/overlay-side-form.service';
import { AnagraficaService } from '../../services/anagrafica.service';
import { ComponentService } from '../../services/component.service';
import { FormsTemplateService } from '../../services/forms-template.service';
import { NicaMenuService } from '../../services/nica-menu.service';
import { RentriService } from '../../services/rentri.service';
import { Utenteservice } from '../../services/utente.service';
import { INavData, navItems } from './_nav';
import { IPartner } from './interfaces';
import { TreCxService } from '../../services/3cx.service';


@Component({
  selector: 'app-crm',
  templateUrl: './crm.component.html',
  styleUrls: ['./crm.component.css']
})
export class CrmComponent extends NicaMaster implements OnInit, OnDestroy {
  @ViewChild('dynamicOutlet', { read: ViewContainerRef, static: true }) dynamicOutlet!: ViewContainerRef;
  @ViewChild('crmSidebar', { static: true }) crmSidebar!: ElementRef;
  public isCollapsed: boolean = false;
  protected navItems: INavData[];
  public partnerData: IPartner = {
    isPartner: false,
    isSegreteria: false,
    id: null
  };
  readonly localStoreKey: string = 'crm_nav_item'
  private dynamicComponentsMap = new Map<string, ComponentRef<any>>();
  private storedData = {}
  private $distruggi: Subject<void> = new Subject<void>()
  constructor(
    public userComponentService: ComponentService,
    public templateService: FormsTemplateService,
    public _overlaySideFormService: OverlaySideFormService,
    public _overlaySidePanelService: OverlaySideFormService,
    public formTemplateService: FormsTemplateService,
    public _componentFactoryResolver: ComponentFactoryResolver,
    public activatedroute: ActivatedRoute,
    public router: Router,
    public menuService: NicaMenuService,
    public rentriService: RentriService,
    public anagraficaService: AnagraficaService,
    private activeRouter: ActivatedRoute,
    private userService: Utenteservice,
    private trecxService: TreCxService

  ) {
    super(
      userComponentService,
      templateService,
      _overlaySideFormService,
      _overlaySidePanelService,
      formTemplateService,
      _componentFactoryResolver,
      activatedroute,
      router,
      menuService,
      rentriService,
      anagraficaService,
    )

  }
  ngOnDestroy(): void {
    this.$distruggi.next()
    this.$distruggi.complete()
    this.$distruggi.unsubscribe()
  }

  ngOnInit() {
    this.initUserInfoAndMenu()
    //! 3CX Connessione WebSocket
    this.trecxService.connect()

    this.activeRouter.queryParams.pipe(takeUntil(this.$distruggi))
      .subscribe(params => {
        //console.log(params)
        this.currentTabId = params.currentTabId;
        this.currentTabName = params.currentTabName;
        this.setGlobalVariableFromParams(params);
      });

    this.userComponentService.castMessage.pipe(takeUntil(this.$distruggi)).subscribe({
      next: (msg: messagefromComponent) => {
        return this.processaMsg(msg)
      },
      error: (errore) => {
        return console.error(errore)
      },
      complete: () => { }
    })
  }

  open<T>(componentName: any, item?: INavData, data?: Partial<T>) {
    this.setActive(item)
    if (this.dynamicComponentsMap.has(componentName)) {
      if (data) {
        Object.assign(this.dynamicComponentsMap.get(componentName).instance, data);
      }
      return
    }
    this.dynamicComponentsMap.clear()
    // Svuotare il contenitore
    if (this.dynamicOutlet) this.dynamicOutlet.clear();
    //Cercare il componente
    const factories = Array.from(this._componentFactoryResolver['_factories'].keys());
    const factoryClass = <Type<any>>factories.find((x: any) => x.name === componentName);
    // Risolvere la ComponentFactory
    const componentFactory = this._componentFactoryResolver.resolveComponentFactory(factoryClass);
    // Creare il componente dinamico
    const componentRef = this.dynamicOutlet.createComponent(componentFactory);
    this.dynamicComponentsMap.set(componentName, componentRef);
    // Aggiungere il componente come figlio del dynamicOutlet
    const dynamicOutletElement = this.dynamicOutlet.element.nativeElement;
    dynamicOutletElement.appendChild(componentRef.location.nativeElement);
    data['partnerData'] = this.partnerData
    //console.log(data)
    // Passare i dati
    if (data) {
      Object.assign(componentRef.instance, data);
    }

    return componentRef;
  }

  closeNav() {
    this.isCollapsed = !this.isCollapsed
    this.storedData['isCollapsed'] = this.isCollapsed
    this.setNavStore(this.storedData)
  }

  private setNavStore(data) {
    sessionStorage.setItem(this.localStoreKey, JSON.stringify(data))
    return data
  }
  private getNavStore() {
    if (sessionStorage.getItem(this.localStoreKey)) {
      //console.log(JSON.parse(sessionStorage.getItem(this.localStoreKey)))
      return JSON.parse(sessionStorage.getItem(this.localStoreKey))
    } else {
      return undefined
    }
  }
  private ctrlNavItem() {
    const navStore = this.getNavStore();
    if (navStore) {
      return this.open(navStore.component, navStore, { titolo: navStore.name });
    }
    const activeItem = this.navItems.find(item => item.active);
    if (!activeItem) {
      console.error('[ctrlNavItem] Nessun item attivo trovato in navItems');
      return;
    }
    if (!activeItem.component) {
      console.error('[ctrlNavItem] Item attivo trovato ma senza "component":', activeItem);
      return;
    }
    this.open(activeItem.component, activeItem, { titolo: activeItem.name });
  }

  private processaMsg(msg: messagefromComponent) {
    if (msg.destComponent !== this.constructor.name) {
      return
    }
    console.log(msg)
    switch (msg.traceMessage) {
      case 'apriContatto':
        const items = this.navItems.filter(item => item.component === 'CrmContattiComponent');
        const dataContatto = msg.Data.Items[0] as Contatto
        const dataToSend = {
          filtroCodAss: dataContatto.CodAss
        }
        this.open('CrmContattiComponent', items[0], dataToSend)

        const message: messagefromComponent = {
          codeMessage: 1,
          traceMessage: 'expandRow',
          destComponent: 'CrmContattiComponent',
          Data: { Items: [dataContatto] }
        }
        this.userComponentService.emitMessage(message)
        return
      default:
        return
    }
  }
  private controlParter(navItems: INavData[], isPartner) {
    if (isPartner) {
      const partnerExclude = ['Dashboard', 'Statistiche', 'Agenti', 'Banche', 'Tags', 'Aggiornamenti', 'Email Inviate']
      navItems.forEach((item: INavData) => {
        if (!partnerExclude.some(ex => item.name.includes(ex))) {
          if (item.name === 'Contatti') item.active = true
          if (typeof item.isTitle === 'boolean' && item.isTitle) item.visible = false
          return
        }
        //alert('ccccccccccccccccccccccccccccccc', '')
        item.visible = false
        item.active = false
        return
      })
    }
    this.navItems = navItems
    this.ctrlNavItem();
  }
  private initUserInfoAndMenu() {
    try {
      const InfoUtenteConnesso: { [key: string]: any } = this.userService.InfoUtenteConnesso
      console.log(InfoUtenteConnesso)
      this.partnerData.isPartner = InfoUtenteConnesso.tipoUtente === 10 //setting del ruolo
      this.partnerData.isSegreteria = InfoUtenteConnesso.tipoUtente === 11 //setting del ruolo
      this.partnerData.id = InfoUtenteConnesso.codiceFiscale
      this.controlParter(navItems, this.partnerData.isPartner);
      const store = this.getNavStore()
      this.isCollapsed = store !== undefined ? store['isCollapsed'] ? store['isCollapsed'] : false : false
    } catch (error) {
      console.error('Errore caricamento info utente', error);
    }
  }
  private setActive(item: INavData) {
    if (!item) {
      return
    }
    this.navItems.forEach((itemNav) => {
      if (itemNav.name === item.name) {
        itemNav.active = itemNav.visible
      } else {
        itemNav.active = false
      }
    })
    this.storedData = item
    this.storedData['isCollapsed'] = this.isCollapsed
    this.setNavStore(this.storedData)
  }
}

